<!-- <div class="container-fluid d-flex align-items-center justify-content-center mainContainer">
  <div class="row w-100"> -->
    <!-- Left Section -->
    <!-- <div class="col-md-8 d-none d-md-flex align-items-center justify-content-center">
      <img src="assets/loginLeft.png" alt="" class="col-12 loginbgImg">
      <img src="assets/logo_icon.png" alt="" class="logoImg">
    </div> -->
    
    <!-- Right Section -->
    <!-- <div class="col-md-4 col-12 d-flex align-items-center justify-content-center rightSection">
      <div class="login-form w-80">
        <h2 class="fw-bold text-xl">Hello Again!</h2>
        <p class="text-muted mt-2">Welcome Back</p> -->
        
        <!-- Updated form with proper bindings -->
        <!-- <form [formGroup]="loginForm" class="pt-4" (ngSubmit)="onLoginClick()">
          <div class="mb-4 fieldContainer">
            <div class="input-group">
              <span class="input-group-text fieldIcons border-0" style="background-color: transparent;">
                <i class="bi bi-envelope"></i>
              </span>
              <input 
                type="email" 
                formControlName="email"
                class="form-control border-0" 
                placeholder="Email Address"
                [class.is-invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
              >
            </div>
           
          </div>

          <div class="mb-4 fieldContainer">
            <div class="input-group">
              <span class="input-group-text fieldIcons border-0">
                <i class="bi bi-lock"></i>
              </span>
              <input 
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                class="form-control border-0" 
                placeholder="Password"
                [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
              >
              <span class="input-group-text fieldIcons border-0 cursor-pointer" (click)="togglePasswordVisibility()">
                <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
              </span>
            </div>
          </div>

          <button 
            type="submit" 
            class="btn btn-primary w-100 py-2"
            [disabled]="loginForm.invalid"
          >
            Login
          </button>

          <div class="mb-3 mt-3 ml-2 d-flex justify-content-between align-items-center">
            <div class="form-check">
              
              <input 
                type="checkbox" 
                class="form-check-input" 
                id="rememberMe"
                formControlName="rememberMe"
              >
              <label class="form-check-label ml-2 mt-1 text-gray-500 " for="rememberMe">Remember me <span class="ml-8 text-purple" (click)="onForgetPassword()">Forgot Password?</span></label>

             
            </div>
           
          </div>
        </form>
        -->
        <!-- <p class="mt-4 text-muted" style="font-size: small;">
          Don’t have an account?
          <span class="text-purple createAccount cursor-pointer" (click)="onCreateAccount()">Create Account</span>
        </p> -->

        
      <!-- </div>
    </div>
  </div>
</div> -->


<div class="maindiv flex flex-col items-center justify-center min-h-screen bg-cover bg-center px-4" style="background-image: url('assets/newui/background.png');">
  <!-- Logo and Welcome Text Container -->
  <div class="text-center">
    <div class="flex justify-center items-center">
      
    </div>

  </div>

  <!-- Form Container -->
  <div class="bg-white formcontainer shadow-lg p-4 sm:p-8 md:p-12 w-full max-w-md mx-4">
    <img src="assets/newui/atlasnewlogo.png" class="w-60 h-28 ml-10 sm:ml-20 mb-2" alt="Atlas Track Logo">
    <p class="text-center text-lg text-muted font-semibold  mb-2">Welcome to Atlas Track</p>
    <h2 class="text-lg sm:text-lg font-bold text-center mb-2">Login to Account</h2>
    <form [formGroup]="loginForm" class="pt-2" (ngSubmit)="onLoginClick()">
        <div class="mb-4">
            <label class="block text-gray-600 text-sm mb-2" for="email">Email Address:</label>
            <input class="w-full px-3 sm:px-4 py-2 border rounded-lg bg-gray-100 text-gray-500" 
              type="email" 
              id="email"  
              formControlName="email"
              placeholder="Email Address"
              [class.invalid-border]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
        </div>
        <div class="mb-4">
            <label class="block text-gray-600 text-sm mb-2" for="password">Password</label>
            <div class="relative">
                <input class="w-full px-3 sm:px-4 py-2 border rounded-lg bg-gray-100 text-gray-500" 
                  [type]="showPassword ? 'text' : 'password'"
                  formControlName="password"
                  placeholder="Password"
                  [class.invalid-border]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                <i class="fas absolute right-3 top-3 text-gray-400" 
                  [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'" 
                  (click)="togglePasswordVisibility()"></i>
                <span class="input-group-text fieldIcons border-0 cursor-pointer">
                  <i class="bi"></i>
                </span>
            </div>
            <div class="flex flex-col sm:flex-row mt-2">
              <div class="flex-0 mb-2 flex items-center">
                <input 
                  type="checkbox" 
                  class="mr-2 ml-0 sm:ml-2" 
                  id="rememberMe"
                  formControlName="rememberMe">
                <label for="remember" class="text-gray-500 text-sm">Remember Password</label>
              </div>
              <div class="text-left sm:text-right mb-2 flex-1 items-center">
                <a class="text-gray-500 text-sm cursor-pointer" (click)="onForgetPassword()">Forget Password?</a>
              </div>
            </div>
        </div>
        <div *ngIf="errorMessage" class="text-red-500 text-sm mb-4 text-center">
          {{ errorMessage }}
        </div>
        <button
          class="w-full sm:w-3/4 sm:ml-12 loginbtn text-white py-2 rounded-lg transition duration-200"
          type="submit" 
          [disabled]="loginForm.invalid">Login</button>
    </form>
    <p class="text-center text-gray-500 text-xs mt-2 mb-4">Don't have an account? <a class="text-purple-500 cursor-pointer" (click)="onCreateAccount()">Create Account</a></p>
</div>
</div>